export const PROGRESS_CANCEL = 'PROGRESS_CANCEL';
export const PROGRESS_DID_CANCEL = 'PROGRESS_DID_CANCEL';

export const cancelProgress = () => ({ type: PROGRESS_CANCEL });
